import { View } from 'components/View'
import PropTypes from 'prop-types'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import getUrlImageUtil from 'components/Image/utils/get-url'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import hasWebpSupportAppSelect from 'modules/training/modules/app/selectors/has-webp-support'

export default function BackgroundImage ({
  source,
  style,
  ...rest
}) {
  const hasWebpSupport = useSelector(hasWebpSupportAppSelect)
  const backgroundImage = getUrlImageUtil(source, hasWebpSupport)
  const currentStyle = {
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    height: '100%'
  }

  return (
    <View
      className='lazyload'
      data-bg={backgroundImage}
      style={getStyleComponentUtil(currentStyle, style)}
      {...rest}
    />
  )
}

BackgroundImage.propTypes = {
  source: PropTypes.string.isRequired,
  hasWebpSupport: PropTypes.bool
}
